import * as Sentry from '@sentry/vue';
import { App } from 'vue';
import { Router } from 'vue-router';

import config from '@/config';
import { UnpackedError } from '@/errors';
import useAuthStore from '@/stores/auth';

import pkg from '../package.json';

export default class SentryApi {
  static init(app: App, router: Router) {
    try {
      Sentry.init({
        enabled: config.sentry.enabled,
        app,
        dsn: config.sentry.dsn,
        environment: config.sentry.environment,
        replaysSessionSampleRate: config.sentry.replaySessions,
        replaysOnErrorSampleRate: config.sentry.errorReplaySessions,
        beforeSend(event) {
          const { username, accountId, role, userId } = useAuthStore();
          event.tags = {
            userId: userId,
            accountId: accountId,
            feature: config.FEATURE,
            username: username,
            role: role,
          };

          return event;
        },
        release: `${config.sentry.project}@${pkg.version}`,
        integrations: [
          Sentry.browserTracingIntegration({ router }),
          Sentry.replayIntegration(),
        ],
        attachStacktrace: true,
        maxBreadcrumbs: config.sentry.maxBreadcrumbs,
        tracesSampleRate: config.sentry.tracesSampleRate,
      });
    } catch (e: unknown) {
      console.error(`Can not initiate Sentry due to: ${e}`);
    }
  }

  static captureException(err: unknown) {
    const unpackedError = new UnpackedError(err);
    Sentry.captureException(unpackedError);
    console.error(unpackedError);
  }
}
